import { useEffect, useState } from 'react'
import { checkIsTenant } from '../../../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import useCheckPermission from '../../../../utils/checkPermission'
import { getItem } from '../../../../utils/storageUtils'
import { getSessionSettingsStart, updateSessionSettingsStart } from '../../../../store/redux-slices/superAdminSettings'

const defaultSessionSettings = {
  loginCount: null,
  userSessionExpiry: null,
  adminSessionExpiry: null,
  superadminSessionExpiry: null
}

const useSessionSettings = () => {
  const dispatch = useDispatch()
  const { tenantDetails } = useSelector(state => state.login)
  const { sessionSettings: settings } = useSelector(state => state.superAdminSettings)
  const { isHidden } = useCheckPermission()
  const { adminDetails } = useSelector(state => state.admins)

  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [sessionSettings, setSessionSettings] = useState(defaultSessionSettings)
  const [isSessionSettingsActive, setIsSessionSettingsActive] = useState(false)
  const isTenant = checkIsTenant()

  const tenantId = getItem('tenant-id')

  useEffect(() => {
    dispatch(getSessionSettingsStart({ selectedPortal: isTenant ? tenantId : selectedPortal }))
  }, [selectedPortal])

  useEffect(() => {
    setSessionSettings({
      loginCount: settings?.loginCount ? settings.loginCount : 0,
      userSessionExpiry: settings?.userSessionExpiry || 0,
      adminSessionExpiry: settings?.adminSessionExpiry || 0,
      superadminSessionExpiry: settings?.superadminSessionExpiry || 0
    })
    if (settings?.loginCount) {
      setIsSessionSettingsActive(true)
    }
  }, [settings])

  const getInitialValues = () => ({
    ...defaultSessionSettings,
    ...sessionSettings
  })

  const handleSubmit = (values) => {
    const payload = {
      tenantId: isTenant ? tenantId : selectedPortal
    }

    if (isTenant || selectedPortal) {
      payload.loginCount = isSessionSettingsActive ? values.loginCount : 0
      payload.userSessionExpiry = isSessionSettingsActive && values?.userSessionExpiry ? values.userSessionExpiry : 0
    }

    if (!isTenant) {
      payload.adminSessionExpiry = values?.adminSessionExpiry ? values.adminSessionExpiry : 0
      payload.superadminSessionExpiry = values?.superadminSessionExpiry ? values.superadminSessionExpiry : 0
    } else {
      payload.adminSessionExpiry = 0
      payload.superadminSessionExpiry = 0
    }

    dispatch(updateSessionSettingsStart({
      data: payload,
      isTenant
    }))
  }

  return {
    tenantDetails,
    selectedClient,
    setSelectedClient,
    selectedPortal,
    setSelectedPortal,
    getInitialValues,
    handleSubmit,
    isHidden,
    isSessionSettingsActive,
    setIsSessionSettingsActive,
    adminDetails,
    isTenant
  }
}

export default useSessionSettings
